import { css, html, LitElement } from "lit";
import { APPS } from "../configuration/constants.js";
import { defineComponent } from "../configuration/utils.js";
export class AppIcon extends LitElement {
    constructor() {
        super();
        this.appKey = null;
        this.size = "lg";
        this._icon = () => html ``;
    }
    willUpdate(_oldProps) {
        if (_oldProps.has("appKey") &&
            this.appKey !== _oldProps.get("appKey") &&
            this.appKey !== null) {
            const app = Object.values(APPS).find((app) => app.key === this.appKey);
            if (app) {
                app.loadIcon();
                this._icon = app.icon;
            }
        }
    }
    render() {
        return this._icon(this.size);
    }
}
AppIcon.properties = {
    appKey: { type: String, reflect: true, attribute: "app-key" },
    size: { type: String, reflect: true, attribute: "size" },
    _icon: { state: true },
};
AppIcon.styles = [
    css `
      :host {
        display: contents;
      }
    `,
];
export const APP_ICON_TAG = "atlas-gn-app-icon";
defineComponent(APP_ICON_TAG, AppIcon);
